<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦平台纠纷处理规则</div>
    <div class="sub_title">第一章 综述总则</div>
    <div class="main_item">
      <h2>第一节&nbsp;综述</h2>
      <p>
        第一条
        为了维护神州邦邦平台公平、和谐的商业氛围，推动服务交易的繁荣，保障买卖双方的合法权益，维护神州邦邦平台正常运营秩序，公平、公正、透明地处理用户纠纷，根据《神州邦邦平台服务协议》及《神州邦邦平台服务规则》等相关规则，制定本规则。
      </p>
      <p>
        第二条
        本规则是构成《神州邦邦平台服务协议》的有效组成部分，具有同等法律效力；两者约定不一致的内容，以本规则的约定为准。
      </p>
      <p style="font-weight: 600">您同意：</p>
      <p style="font-weight: 600">
        工程师在神州邦邦平台上交易与雇主发生交易纠纷时，一旦工程师或雇主的任一方或双方共同提交神州邦邦平台要求调处，则神州邦邦平台有权根据神州邦邦平台相关规则进行处理。神州邦邦平台处理纠纷完全基于您的委托，秉持公平、公正、透明的原则调解纠纷。神州邦邦平台将根据行业认知以及专家意见对调解案件进行判断和建议，但神州邦邦平台并非司法或行政机构，不保证调解结论和处理结果符合您的期望，亦不对处理结果承担任何责任。
      </p>
      <p>第三条 调处受理期限</p>
      <p>
        工程师或雇主的任意一方或双方应在交易完成30天内或售后维护时限内发起调处申请。
        本规则所称“售后维护时限”双方有约定的以约定时间为准，双方无约定，若类目对售后争议处理的受理有特殊规定的，依照类目的特殊规定。
      </p>
      <p>第四条 调处受理范围</p>
      <p>
        神州邦邦平台受理工程师或雇主的任一一方或双方在神州邦邦平台产生的交易纠纷调处申请，但出现以下情形的，神州邦邦平台可不予受理，工程师或雇主任一方有权自行通过司法机关等途径向相对方主张权利：
      </p>
      <ul class="content_wrap1">
        <li>
          <p>未使用神州邦邦平台进行交易（包括但不限于：线下交易等）；</p>
        </li>
        <li>
          <p>未在本规则规定的受理期限内发起；</p>
        </li>
        <li>
          <p>
            交易订单显示的服务与双方约定的实际交易服务不一致，导致交易事实无法查清或实际交易服务违反神州邦邦平台相关规则的规定；
          </p>
        </li>
        <li>
          <p>双方经自行协商达成退款协议并履行完毕，一方或双方反悔产生争议；</p>
        </li>
        <li>
          <p>双方进行虚假交易或利用信用卡、花呗等实施套现且交易成功；</p>
        </li>
        <li>
          <p>交易做退款处理后，因雇主需要取回商品产生争议；</p>
        </li>
        <li>
          <p>拒不提供身份证明；</p>
        </li>
        <li>
          <p>
            除神州邦邦平台规则规定的情形外，工程师或雇主任一方或双方主张交易引发的额外损失或法定赔偿。
          </p>
        </li>
      </ul>
      <p>
        第五条
        本规则只适用于中华人民共和国大陆境内交易产生的纠纷，涉及到此范围以外的纠纷，不适用本规则。
      </p>
    </div>
    <div class="main_item">
      <h2>第二节&nbsp;总则</h2>
      <p>第五条 身份核实</p>
      <p>
        纠纷处理过程中，神州邦邦平台可要求您提供身份证明，拒不提供身份证明的，神州邦邦平台将不予接受其纠纷处理申请或者可能做出不利于该方的处理。
      </p>
      <p>第六条 举证责任</p>
      <ul class="content_wrap1">
        <li>
          <p>
            工程师或雇主应当围绕自己的主张或答辩意见举示相应的证据，否则可能承担举证不能的不利后果；
          </p>
        </li>
        <li>
          <p>工程师或雇主应当自发起或收到调处申请之日起3日内完成全部举证；</p>
        </li>
        <li>
          <p>
            对需求完成情况的说明应根据需求要求提供包括完成的交付交流过程、最终签收文件等证据资料；
          </p>
        </li>
        <li>
          <p>
            雇主主张工程师未按照要求完成需求的，且工程师已按照神州邦邦平台要求出具本条第一项约定证明文件。雇主应当根据要求出具相应测试检查报告；
          </p>
        </li>
        <li>
          <p>
            纠纷双方均同意，因交易双方约定不清而产生交易纠纷的，撤销该交易，因此导致的损失由交易双方共同承担，具体承担比例由神州邦邦平台根据具体情况判断；
          </p>
        </li>
        <li>
          <p>
            纠纷双方同意，在纠纷处理过程中，当工程师或雇主任何一方如出现以下情况：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                更换联系方式未通知神州邦邦平台或对方以致在纠纷处理过程中无法联系；
              </p>
            </li>
            <li>
              <p>
                神州邦邦平台三次联系任何一方（无论任何途径）均无法在纠纷上进行实质沟通；
              </p>
            </li>
            <li>
              <p>
                拒接电话、无人接听、在通话中因不属于神州邦邦平台的原因中断等任何一种或各种情况累加达三次；
              </p>
            </li>
            <li>
              <p>恶意辱骂工作人员导致无法沟通。</p>
            </li>
          </ul>
        </li>
      </ul>
      <p>
        平台将视该方自愿放弃辩解的权利。平台将依据现有证据给出处理意见。神州邦邦平台将以站内信、短信、邮件等形式通知其纠纷处理的进度及结果。
        纠纷双方同意，神州邦邦平台将根据行业认知以及专家意见对调解案件进行判断和建议，纠纷双方需自行对证据的真实性、完整性、合法性、准确性和及时性负责，并承担举证不能的后果。
      </p>
      <p>
        第八条
        神州邦邦平台有权根据实际情况，视情节轻重在既有规定基础之上予以从轻、减轻或免除处理。
      </p>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">
      第二章 交易规范及纠纷责任划分
    </div>
    <div class="main_item">
      <h2>第一节&nbsp;需求内容的确认</h2>
      <p>
        第九条
        需求一经发布，工程师参与接单、或接收到雇佣或购买服务的需求并同意开始工作的，即视为工程师认可并同意需求。期间雇主补充的需求仅作为对原有需求的补充和说明，工程师可以选择不予认可新增需求。雇主提出的修改建议需得到工程师的确认方能生效，未经双方确认的修改建议，神州邦邦平台不予认可并且不作为纠纷处理依据。
      </p>
      <p>
        第十条
        工程师接收到雇佣或购买服务需求，在工程师确认开始工作前需与雇主确认需求内容，确认后同意开始工作。若因工程师未确认需求内容导致纠纷产生，由工程师承担全部责任；若工程师已确认需求内容，但因需求内容约定不清、文字内容存在歧义等导致双方产生纠纷的，责任由交易双方共同承担，具体承担比例由神州邦邦平台根据具体情况判断。
      </p>
      <p>
        第十一条
        交易合同内容规定：协议条款需遵从神州邦邦平台规则以及平台交易流程，若协议中存在违反平台规则或流程，神州邦邦平台不予认可该项协议条款。若交易双方签署的线上合同和线下合同内容冲突或不一致的，以后一份签署的合同内容为准。
      </p>
      <p>
        第十二条
        工程师承诺赠送给雇主的服务，赠送内容需遵从神州邦邦平台的各项规则，同时需按时按质按量交付于雇主。若雇主实际得到的赠送服务与工程师的描述不符，或工程师未明确告知雇主赠送服务的实际内容，导致纠纷产生，平台视为工程师“承诺未兑现”并按照该条条款进行处理。
      </p>
    </div>
    <div class="main_item">
      <h2>第二节&nbsp;需求时限的确认</h2>
      <p>
        第十三条
        议价单交易中，若雇主在发布需求时未进行特别说明，雇主选标后，工程师需与雇主自行约定后期完成交付的时间。若因工程师未确认完成交付的时间导致纠纷产生，由工程师承担全部责任；
      </p>
      <p>
        第十四条
        雇佣和购买服务中，工程师同意按照双方在需求开始前约定的完成期限执行，交易过程中若双方约定延长完成期限，按照延长后的期限为准。若因工程师未约定工作完成期限导致纠纷产生，由工程师承担全部责任；若工程师已约定工作完成期限导致纠纷产生，但因工期约定不清、文字内容存在歧义导致双方产生纠纷的，责任由交易双方共同承担，具体承担比例由神州邦邦平台根据具体情况判断。
      </p>
      <p>
        第十五条
        约定期限到期但工程师尚未交付工作时，若双方继续交易，双方需重新约定服务时间。否则雇主有权随时要求工程师在合理时间(该合理时间应以雇主主张时起算，不得少于3个工作日)内完成工作，最终工作期限以雇主要求为准。
      </p>
    </div>
    <div class="main_item">
      <h2>第三节&nbsp;交易过程</h2>
      <p>
        第十六条
        双方约定期限届满前，工程师已产生实质服务行为的，或工程师依约已完成服务的，雇主要求退款或拒绝接受服务的，需与工程师协商一致，协商无法达成一致的，可申请官方介入，若官方调解失败则交易按原“合同”履行或雇主可以通过司法机关等途径向相对方主张权利。
      </p>
      <p>
        第十七条
        在服务过程中，若基于服务履行之必要，需要雇主配合提供协助的，或对雇主的配合行为存在时限要求的，工程师应当与雇主事先约定一致，或在服务详情页或交易合同中予以显著明示并提请雇主注意相关条款。否则雇主有权拒绝并由工程师承担交易不利后果。
      </p>
      <p>
        第十八条
        工程师向雇主提出配合请求的，雇主应在合理期限内予以配合。若雇主无正当理由怠于或拒绝提供必要的配合，导致工程师服务成本增加、服务履行期限延迟、服务成果无法实现等不利后果的，应由雇主承担不利后果，但工程师仍应及时中止履行服务并采取合理措施防止服务成本的扩大。
      </p>
      <p>在上述雇主责任情形下，相关交易作如下处置：</p>
      <ul class="content_wrap1">
        <li>
          <p>
            若工作成果完全无法实现，但工程师确已产生服务成本的，雇主在承担相应的服务成本后，交易作退款处理；
          </p>
        </li>
        <li>
          <p>
            若工作成果已部分实现，则综合评估该部分服务成果的价值比例，并结合订单金额酌情计算其对应价款，交易作部分打款、部分退款处理；
          </p>
        </li>
        <li>
          <p>
            若工作成果已部分实现，同时，剩余未实现的服务成果也已产生服务成本。则分别依照上述第一、二项处理方法，计算应支付的价款与应承担的服务成本。
          </p>
          <p>
            “合理期限”：指工程师通过雇主应当知晓的其他方式（如手机短信）向雇主发出通知要求配合之时的次日起48小时内。
          </p>
          <p>
            “服务成本”：指工程师在提供服务的过程中产生的必要费用支出，具体将由神州邦邦平台根据工程师举证，结合行业认知以及专家意见对调解案件进行判断和建议，但最高不超过订单实际成交金额。
          </p>
        </li>
      </ul>
      <p>
        第十九条
        雇主提出的需求或修改意见存在无法实施等情况，工程师应提醒雇主其中存在的风险。相关交易纠纷作以下处理：
      </p>
      <ul class="content_wrap1">
        <li>
          <p>
            若工程师已提醒雇主其中存在的风险，而雇主执意要求工程师按自己要求提供服务，导致工程师提供的服务存在问题、无法正常使用等情况，相关责任和损失由雇主自行承担。
          </p>
        </li>
        <li>
          <p>
            若工程师未提醒雇主其中存在的风险直接执行，导致工程师提供的服务存在问题、无法正常使用等情况，相关责任和损失由交易双方共担。
          </p>
        </li>
        <li>
          <p>若交易双方另有约定按其约定执行。</p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第四节&nbsp;工作交付</h2>
      <p>
        第二十条
        工程师交付服务成果时需要返还雇主事先提供用于该服务的物品的，若工程师拒绝返还或返还途中非因雇主原因导致物品损毁或灭失的，依据该物品价值及贬损程度，工程师需向雇主进行赔偿，若双方事先未有约定，赔偿金额由神州邦邦平台根据雇主提供的物品价值有效凭证或参照当前市场均价予以酌定，神州邦邦平台有权从工程师所缴纳的保证金中划扣与之相等的款项退还给雇主，以弥补雇主损失。对于客观上难以估值的物品，神州邦邦平台将应雇主要求披露工程师信息，以协助雇主通过司法途径向工程师进行主张。
      </p>
      <p>
        第二十一条
        上述情形下，若服务成果已交付且不影响雇主合同目的实现的，交易作打款处理，反之，交易作退款处理。合同目的实现与否，神州邦邦平台将基于服务内容，并以普通大众的认知水准及日常经验进行判断。
      </p>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">第三章 雇主责任</div>
    <div class="main_item">
      <p>
        第二十二条
        无理要求：指雇主提出超出合同约定、额外的不合理的要求。当工程师提出雇主无理要求，无法完成的，一旦成立，雇主需根据工程师的工作情况支付相应的赏金，同时神州邦邦平台有权对雇主第一次处以警告处理；
      </p>
      <p>
        第二十三条
        雇主在未验收需求结果或需求结果与要求不一致的情况下确认付款，雇主需自行承担所有损失，且神州邦邦平台将驳回雇主的相关官方调解申请。
      </p>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">
      第四章 工程师违规处理条例
    </div>
    <div class="main_item">
      <p>
        第二十四条
        未按时完成工作：指雇主与工程师明确约定工作期限，工作期限（含变更期限）届满，工程师因自身原因工作（含变更内容）未完成。
        约定的工作期限包括但不限于：
      </p>
      <ul class="content_wrap1">
        <li>
          <p>协议及补充协议约定的时间；</p>
        </li>
        <li>
          <p>聊天记录中双方另行约定的时间；</p>
        </li>
      </ul>
      <p>
        若工程师未按时完成工作，双方有约定的，按照约定办理；若双方没有约定的，雇主与工程师继续就需求继续磋商，工程师继续完成工作的，将视为双方变更工作期限，该变更工作期限双方未有明确约定的，雇主有权随时要求工程师在合理时间（合理时间应以雇主主张时起算，不得少于3个工作日）内完成工作，最终工作期限以雇主要求为准。若双方没有约定且终止合作的，工程师应当全额退款给雇主，同时神州邦邦平台有权对工程师处以限制报名7天，并扣除500元保证金的处理；
      </p>
      <p>
        第二十五条
        诱导选标、付款：工程师通过故意曲解神州邦邦平台规则和交易流程等方式诱骗雇主选标、付款的行为。诱导行为包括但不限于：
      </p>
      <ul class="content_wrap1">
        <li>
          <p>工程师冒用他人案例作为自己的案例向雇主展示的；</p>
        </li>
        <li>
          <p>工程师伪造自身学历，或工作经验，诱导雇主下单或选标或支付的；</p>
        </li>
        <li>
          <p>
            个人认证工程师以企业认证身份接单的（工程师线下为企业，但在神州邦邦平台上为个人认证，工程师同样不能以企业身份在神州邦邦平台接单）；
          </p>
        </li>
      </ul>
      <p>
        雇主反馈工程师恶意诱导雇主选标、付款，一旦成立，可要求终止交易，交易支持退款给雇主，具体退款比例由神州邦邦平台根据具体情况判断为全额退款或部分退款，另神州邦邦平台有权对工程师处以扣除500元保证金的处理。
      </p>
      <p>
        第二十六条
        工程师失联：是指工程师提供的联系方式无效，或怠于处置、消极应对、拒不配合处理订单或提交相关资料等情形。“失联”的界定包含但不限于以下情形：
      </p>
      <ul class="content_wrap1">
        <li>
          <p>
            神州邦邦平台在接到雇主反映联系不上工程师后，通过电话、短信、邮件、站内信等方式联系工程师，在48小时内仍无法和工程师取得联系的情况；
          </p>
        </li>
        <li>
          <p>
            雇主有证据能证明工程师在未进行事先告知的情况下，连续72小时雇主都联系不上工程师的情况；
          </p>
        </li>
        <li>
          <p>更换联系方式未通知神州邦邦平台或对方以致在处理过程中无法联系；</p>
        </li>
        <li>
          <p>
            神州邦邦平台在不同时间段连续三次联系（无论任何途径）均无法在纠纷上进行实质沟通
          </p>
        </li>
        <li>
          <p>
            拒接电话、无人接听、在通话中因不属于神州邦邦平台的原因中断等任何一种或各种情况累加达三次；
          </p>
        </li>
        <li>
          <p>恶意辱骂工作人员导致无法沟通。</p>
        </li>
      </ul>
      <p>
        工程师在未完成工作的情况下失联引起雇主投诉的，交易支持全额退款给雇主，神州邦邦平台有权对工程师处以限制报名7天，并扣除500元保证金的处理。
      </p>
      <p>
        若工程师在交易过程中失联后继续工作，并按双方约定完成工作的，交易不支持退款，同时神州邦邦平台有权对工程师处以单次限制报名7天，并扣除500元保证金的处理。
      </p>
      <p>
        第二十七条
        承诺未兑现：指工程师未履行其已承诺的服务，交易支持全额退款给雇主，神州邦邦平台有权对工程师处以限制报名7天，扣除500元保证金的处理。若该订单已经产生支付的，则由神州邦邦平台从工程师所缴纳的保证金中划扣与该交易中雇主所支付金额相等的款项退还给雇主，以弥补雇主损失。
      </p>
      <p>
        当工程师承诺退款给雇主，但未履行的，神州邦邦平台有权对工程师处以限制报名7天，扣除保证金500元的处理。
      </p>
    </div>
    <div class="sub_title" style="margin-top: 0.4rem">
      第五章 附则
    </div>
    <div class="main_item">
      <p>第二十八条 因神州邦邦平台系普通的第三方交易平台，并非专业的司法机构或鉴定机构，神州邦邦平台不对评判结果承担法律责任。</p>
      <p>在神州邦邦平台对服务成本、损失或价款等给付内容的进行酌定并实施款项分割前，工程师或雇主任一方均可向神州邦邦平台提出中止纠纷处理服务，并通过司法途径向对方发起诉讼。</p>
      <p>若神州邦邦平台已经作出服务成本、损失或价款等给付内容的酌定并已实施款项分割的，并不影响双方通过司法途径继续向对方提出主张。</p>
      <p>第二十九条 神州邦邦平台有权变更本规则并在神州邦邦平台上予以公告。雇主和（或）工程师不同意相关变更的，可以自行协商或通过其他途径解决纠纷。</p>
      <p>第三十条 神州邦邦平台用户的行为，发生在本规则生效或修订以前的，适用当时的规则；发生在本规则生效或修订以后的，适用本规则。</p>
      <p>第三十一条 本规则自公布之日起生效并实行。</p>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.sub_title {
  font-size: 0.3rem;
  text-align: center;
  font-weight: 900;
  padding: 0 0 0.4rem;
}
</style>